<template>
    <el-button :type="type" :size="size" :loading="loading" :disabled="disabled" @click="click">{{label}}</el-button>
</template>
<script>
export default {
    props:{
        type:{
            type:String,
            default:'primary'
        },
        size:{
            type:String,
            default:'mini'
        },
        loading:{
            type:Boolean,
            default:false
        },
        disabled:{
            type:Boolean,
            default:false
        },
        label:{
            type:String,
            default:'按钮'
        }
    },
    data(){
        return{
            btnStatus:true,
            stopTime:null
        }
    },
    methods:{
        click(){
            if(this.btnStatus){
                this.btnStatus=false
                this.$emit('click')
            }
            this.setTime()
        },
        setTime(){
            clearTimeout(this.stopTime)
            this.stopTime=setTimeout(()=>{
                this.btnStatus=true
            },1000)
        }
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Button.vue